// Para-aware course + awareness reel series (bilingual)

export const courseLessons = [
  {
    id: "why",
    icon: "HeartHandshake",
    de: { t: "Warum Para-aware?", d: "Para-Reiter:innen sind Teil des Sports – aber im Amateurbereich fehlt oft das Wissen über ihre Bedürfnisse. Bewusstsein schafft Sicherheit für alle in Halle und Stall." },
    en: { t: "Why para-aware?", d: "Para-equestrians are part of the sport – yet at amateur level knowledge about their needs is often missing. Awareness creates safety for everyone in arena and stable." },
  },
  {
    id: "grades",
    icon: "Layers",
    de: { t: "Klassifizierung verstehen (Grad I–V)", d: "Fünf Grade nach funktioneller Fähigkeit: Grad I (schwerste Einschränkung, meist Schritt) bis Grad V (geringste, alle Gangarten). Der Grad bestimmt Gangarten und zugelassene Hilfsmittel." },
    en: { t: "Understand classification (Grades I–V)", d: "Five grades by functional ability: Grade I (most severe, usually walk) to Grade V (least, all gaits). The grade determines gaits and permitted aids." },
  },
  {
    id: "helpers",
    icon: "Users",
    de: { t: "Sidewalker & Leader – Rollen", d: "Leader führt das Pferd, Sidewalker stabilisieren den Reiter. Grundregel: stabilisieren, NICHT tragen – außer beim Auf-/Absteigen und im Notfall. Immer wachsam, Ausweg frei." },
    en: { t: "Sidewalkers & leaders – roles", d: "The leader guides the horse, sidewalkers stabilise the rider. Core rule: stabilise, do NOT carry – except mounting/dismounting and in emergencies. Always vigilant, escape route clear." },
  },
  {
    id: "equipment",
    icon: "Wrench",
    de: { t: "Adaptive Ausrüstung", d: "Loop-/Gummizügel, Haltegriff, angepasster Sattel, Sicherheits-Steigbügel, zwei Gerten statt Schenkelhilfen, Auf-/Absteighilfe. Im Turnier nur genehmigte Hilfsmittel (Master List)." },
    en: { t: "Adaptive equipment", d: "Loop/rubber reins, handhold, adapted saddle, safety stirrups, two whips instead of leg aids, mounting aid. In competition only approved aids (Master List)." },
  },
  {
    id: "emergency",
    icon: "Siren",
    de: { t: "Notfall & Kommunikation", d: "Kontrolliertes Absteigen vorab üben. Kommunikation anpassen: gehörlos → visuelle Signale, blind → Caller. Medizinisches beachten (Anfälle, Spastik, Sensibilität). Pflicht-Check nach Sturz." },
    en: { t: "Emergency & communication", d: "Rehearse a controlled dismount in advance. Adapt communication: deaf → visual signals, blind → callers. Mind medical factors (seizures, spasticity, sensation). Mandatory check after a fall." },
  },
  {
    id: "etiquette",
    icon: "Handshake",
    de: { t: "Hallen-Knigge & Inklusion", d: "Kein Überholen ohne Ansage, ruhige Hilfen, genug Abstand, Tempo anpassen. Frag nach, statt anzufassen. Kleine Rücksicht – großer Unterschied." },
    en: { t: "Arena etiquette & inclusion", d: "No overtaking without notice, quiet aids, enough distance, adapt pace. Ask before you touch. Small consideration – big difference." },
  },
];

export const courseQuiz = [
  {
    id: "q1",
    de: "Was ist die Grundregel für Sidewalker?",
    en: "What is the core rule for sidewalkers?",
    options: [
      { de: "Den Reiter jederzeit festhalten und tragen", en: "Hold and carry the rider at all times" },
      { de: "Stabilisieren, aber nicht tragen (außer Auf-/Absteigen & Notfall)", en: "Stabilise, but not carry (except mounting/dismounting & emergency)" },
      { de: "Nur zuschauen und nichts tun", en: "Just watch and do nothing" },
    ],
    correct: 1,
    de_exp: "Sidewalker stabilisieren und sind wachsam – tragen nur bei Auf-/Absteigen oder im Notfall.",
    en_exp: "Sidewalkers stabilise and stay vigilant – they only carry when mounting/dismounting or in an emergency.",
  },
  {
    id: "q2",
    de: "Welcher Grad hat in der Regel die schwerste Einschränkung?",
    en: "Which grade usually has the most severe impairment?",
    options: [
      { de: "Grad V", en: "Grade V" },
      { de: "Grad III", en: "Grade III" },
      { de: "Grad I", en: "Grade I" },
    ],
    correct: 2,
    de_exp: "Grad I bezeichnet die schwerste Einschränkung, meist wird im Schritt geritten.",
    en_exp: "Grade I denotes the most severe impairment, usually ridden at walk.",
  },
  {
    id: "q3",
    de: "Wie kommunizierst du am besten mit einem gehörlosen Reiter in der Halle?",
    en: "How do you best communicate with a deaf rider in the arena?",
    options: [
      { de: "Lauter rufen", en: "Shout louder" },
      { de: "Visuelle Signale / vereinbarte Handzeichen", en: "Visual signals / agreed hand signs" },
      { de: "Gar nicht kommunizieren", en: "Do not communicate at all" },
    ],
    correct: 1,
    de_exp: "Visuelle Signale und vorab vereinbarte Handzeichen sind zuverlässig.",
    en_exp: "Visual signals and pre-agreed hand signs are reliable.",
  },
  {
    id: "q4",
    de: "Was gilt für Hilfsmittel im Turnier?",
    en: "What applies to aids in competition?",
    options: [
      { de: "Alles ist erlaubt", en: "Anything is allowed" },
      { de: "Nur genehmigte Hilfsmittel laut Classification Master List", en: "Only approved aids per the Classification Master List" },
      { de: "Hilfsmittel sind grundsätzlich verboten", en: "Aids are generally forbidden" },
    ],
    correct: 1,
    de_exp: "Nicht genehmigte Hilfsmittel können zur Disqualifikation führen.",
    en_exp: "Unauthorised aids can lead to disqualification.",
  },
  {
    id: "q5",
    de: "Was tust du beim Überholen in der Halle?",
    en: "What do you do when overtaking in the arena?",
    options: [
      { de: "Einfach schnell vorbei", en: "Just pass quickly" },
      { de: "Vorher laut ansagen und genug Abstand halten", en: "Announce beforehand and keep enough distance" },
      { de: "Von hinten anschleichen", en: "Sneak up from behind" },
    ],
    correct: 1,
    de_exp: "Ansage + Abstand verhindern Schreckreaktionen des Pferdes.",
    en_exp: "Notice + distance prevent the horse from spooking.",
  },
  {
    id: "q6",
    de: "Nach einem Sturz eines Para-Reiters …",
    en: "After a para-rider's fall …",
    options: [
      { de: "sofort wieder aufsteigen lassen", en: "let them remount immediately" },
      { de: "verpflichtender Check / Assessment vor dem Weiterreiten", en: "mandatory check / assessment before continuing" },
      { de: "ignorieren, wenn er lacht", en: "ignore it if they laugh" },
    ],
    correct: 1,
    de_exp: "Ein Pflicht-Assessment nach jedem Sturz ist Standard (RDA/FEI).",
    en_exp: "A mandatory assessment after every fall is standard (RDA/FEI).",
  },
];

export const awarenessReels = [
  {
    id: "reel1",
    de: { hook: "„Was macht ein Sidewalker eigentlich?“", script: "1) Frage einblenden. 2) Sidewalker zeigt: Hand an Knie, nicht tragen. 3) Text: stabilisieren – nicht tragen (außer Notfall).", visual: "Nahaufnahme Hand am Knie, ruhige Kamera, Schrift-Overlays in Bronze/Sonne." },
    en: { hook: "\u201cWhat does a sidewalker actually do?\u201d", script: "1) Show the question. 2) Sidewalker shows: hand at knee, not carrying. 3) Text: stabilise – not carry (except emergency).", visual: "Close-up of hand at knee, calm camera, text overlays in bronze/sonne." },
  },
  {
    id: "reel2",
    de: { hook: "Awareness-Ride: einhändig reiten", script: "1) Reiter bindet einen Arm ab. 2) Versucht eine Volte. 3) Text: So fühlt sich Grad III an. Respekt.", visual: "Weitwinkel Halle, Split-Screen vorher/nachher, warmes Licht." },
    en: { hook: "Awareness ride: riding one-handed", script: "1) Rider ties one arm. 2) Attempts a volte. 3) Text: This is what Grade III feels like. Respect.", visual: "Wide arena shot, before/after split-screen, warm light." },
  },
  {
    id: "reel3",
    de: { hook: "Hallen-Knigge in 15 Sekunden", script: "1) Falsch: schnelles Überholen. 2) Richtig: Ansage + Abstand. 3) Text: Rücksicht kostet nichts.", visual: "Zwei kurze Szenen, roter/grüner Rahmen, schneller Schnitt." },
    en: { hook: "Arena etiquette in 15 seconds", script: "1) Wrong: fast overtaking. 2) Right: notice + distance. 3) Text: Consideration costs nothing.", visual: "Two short scenes, red/green frame, fast cut." },
  },
  {
    id: "reel4",
    de: { hook: "3 adaptive Hilfsmittel, die Leben leichter machen", script: "1) Loop-Zügel. 2) Haltegriff. 3) Sicherheits-Steigbügel. Text: Sicherheit ist individuell.", visual: "Produkt-Detailshots am Pferd, ruhige Schwenks, Bronze-Akzente." },
    en: { hook: "3 adaptive aids that make life easier", script: "1) Loop reins. 2) Handhold. 3) Safety stirrups. Text: Safety is individual.", visual: "Product detail shots on the horse, calm pans, bronze accents." },
  },
  {
    id: "reel5",
    de: { hook: "Von der Kapitänin: Checklisten retten – auch beim Para-Reiten", script: "1) Cockpit-Bild. 2) Schnitt in die Halle. 3) Text: Ein System für alle Reiter.", visual: "Match-Cut Cockpit → Sattel, cinematisch, Marke Circle of Ikarus." },
    en: { hook: "From the captain: checklists save – also in para-riding", script: "1) Cockpit shot. 2) Cut to the arena. 3) Text: One system for all riders.", visual: "Match-cut cockpit → saddle, cinematic, Circle of Ikarus branding." },
  },
];
